module.exports = __webpack_public_path__ + "img/Default-J-13.6518ff2b.svg";